/*******************************************************************************
* @license
* Copyright (c) 2016 - present Accedo. All Rights Reserved.
* 
* This source code, its use, and distribution, is subject to the terms
* and conditions of the applicable license agreement.
* 
* VDK Web ProgramGuide Component (@accedo/vdkweb-epg) 7.2.8
* 
*******************************************************************************/
"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getChannelsFromGridDataMem = exports.getChannelsFromGridData = exports["default"] = exports.ProgramGuide = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactFastCompare = _interopRequireDefault(require("react-fast-compare"));
var _redux = require("redux");
var _momentMini = _interopRequireDefault(require("moment-mini"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _transition = require("../utils/transition");
var _DataGridView = _interopRequireDefault(require("../components/DataGrid/DataGridView"));
var _MovableDataGrid = _interopRequireDefault(require("../components/DataGrid/MovableDataGrid"));
var _ProgramGuideTileWrapper = _interopRequireDefault(require("../components/ProgramGuideTileWrapper"));
var _ErrorTile = _interopRequireDefault(require("../components/ErrorTile"));
var _ChannelColumn = _interopRequireDefault(require("../components/ChannelColumn"));
var _Timeline = _interopRequireDefault(require("../components/Timeline"));
var _CurrentTimeMarker = _interopRequireDefault(require("../components/CurrentTimeMarker"));
var _NavigationButton = _interopRequireWildcard(require("../components/NavigationButton"));
var _coordinateUtils = require("../utils/coordinateUtils");
var _timeHelper = require("../utils/timeHelper");
var _gridDataHelper = require("../utils/gridDataHelper");
var _tvListings = require("../utils/tvListings");
var _withTimeProvider = _interopRequireDefault(require("../hocs/withTimeProvider"));
var _withSizeHandler = _interopRequireDefault(require("../hocs/withSizeHandler"));
var _programGuide = _interopRequireDefault(require("./programGuide.scss"));
var _general = require("../utils/general");
var _excluded = ["autoSize"],
  _excluded2 = ["autoUpdate"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
/* eslint-disable eslint-comments/disable-enable-pair */
/* eslint-disable class-methods-use-this */
/* eslint-disable react/no-unused-class-component-methods */
var defaultLeftColumnWidth = 120;
var defaultHeaderHeight = 40;
var DefaultBodyContainer = function DefaultBodyContainer(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement("div", null, children);
};
DefaultBodyContainer.propTypes = {
  children: _propTypes["default"].node
};
var defaultComponents = {
  BodyContainer: DefaultBodyContainer,
  ChannelColumn: _ChannelColumn["default"],
  CurrentTimeMarker: _CurrentTimeMarker["default"],
  ErrorTile: _ErrorTile["default"],
  NavigationButton: _NavigationButton["default"],
  ProgramGuideTile: _ProgramGuideTileWrapper["default"],
  Timeline: _Timeline["default"]
};
var AnimationProp = {
  Enabled: {
    disabled: false
  },
  Disabled: {
    disabled: true
  }
};
var channelColumnNav = {
  id: 'channel-column'
};

/**
 * Extracts the TV listings (channel) data from the coordinate grid data structure.
 * Mainly used to be able to form the channel list column next to the program grid.
 *
 * @param {object} gridData The object containing all coordinate grid data.
 * @returns {array} A list of channels
 */
var getChannelsFromGridData = function getChannelsFromGridData(gridData) {
  return Object.entries(gridData).map(function (_ref2) {
    var _ref3 = _slicedToArray(_ref2, 2),
      _ref3$ = _ref3[1],
      item = _ref3$ === void 0 ? {} : _ref3$;
    var _ref4 = Object.entries(item).find(function (_ref6) {
        var _ref7 = _slicedToArray(_ref6, 2),
          isLoaded = _ref7[1].isLoaded;
        return isLoaded;
      }) || [],
      _ref5 = _slicedToArray(_ref4, 2),
      firstLoadedRow = _ref5[1];
    return (0, _get2["default"])(firstLoadedRow, 'data.content.channels', []);
  }).reduce(function (acc, channels) {
    return [].concat(_toConsumableArray(acc), _toConsumableArray(channels));
  }, []);
};
exports.getChannelsFromGridData = getChannelsFromGridData;
var channelsFromGridDataCache = new Map();
var getChannelsFromGridDataMem = function getChannelsFromGridDataMem(gridData) {
  var channels = getChannelsFromGridData(gridData);
  var key = channels.map(function (_ref8) {
    var channelId = _ref8.channelId;
    return channelId;
  }).join('_');
  if (!(0, _reactFastCompare["default"])(channelsFromGridDataCache.get(key), channels)) {
    channelsFromGridDataCache.set(key, channels);
  }
  return channelsFromGridDataCache.get(key);
};
exports.getChannelsFromGridDataMem = getChannelsFromGridDataMem;
var emptyObj = {};

// eslint-disable-next-line valid-jsdoc
/**
 * A program guide component based on a data grid loading approach.
 * Example features:
 *
 * * Focus navigation with keys
 * * Paginated data loading
 * * Customisable inner components
 *
 * @returns {node} The program guide
 */
var ProgramGuide = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(ProgramGuide, _React$PureComponent);
  var _super = _createSuper(ProgramGuide);
  function ProgramGuide(props) {
    var _this;
    _classCallCheck(this, ProgramGuide);
    _this = _super.call(this, props);
    /**
     * Triggered when new coordinate data should be loaded.
     * Maps coordinates to data range in order to know which
     * TV listings information to fetch.
     *
     * @param {object} coordinate The tile coordinate to get data for
     * @param {string} dataId The data ID of the realm in which the data belongs
     * @returns {promise} A promise of TV listings data
     */
    _defineProperty(_assertThisInitialized(_this), "onLoadCoordinateData", function (coordinate, dataId) {
      var _this$props = _this.props,
        onGetTvListings = _this$props.onGetTvListings,
        onDataLoaded = _this$props.onDataLoaded;
      if (!onGetTvListings) {
        return Promise.reject();
      }
      var dataRange = _this.getDataRange();
      var range = (0, _coordinateUtils.coordinateToDataRange)(coordinate, dataRange);
      var xFrom = range.xFrom,
        xTo = range.xTo,
        yFrom = range.yFrom;
      var parameters = {
        startTime: xFrom,
        endTime: xTo,
        offset: yFrom,
        count: dataRange.yStep
      };
      return onGetTvListings(parameters, dataId).then(function (data) {
        var entries = data.entries || [];

        // Append a global channel index prop.
        // Needed for rendering the channel column properly.
        var channels = entries.map(function (c, channelIndex) {
          return _objectSpread(_objectSpread({}, c), {}, {
            programs: _this.props.splitProgramsByTimespan ? (c.programs || []).reduce((0, _tvListings.getProgramsSplitReduceFn)({
              displayTimespan: _this.props.displayTimespan,
              epgEndTime: _this.props.endTime,
              epgStartTime: _this.props.startTime,
              parameters: parameters
            }), []) : c.programs,
            __channelIndex: yFrom + channelIndex
          });
        });
        onDataLoaded && onDataLoaded({
          channels: channels,
          range: parameters,
          coordinate: coordinate
        });
        return {
          content: {
            channels: channels
          },
          range: range
        };
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onCoordinateChange", function (coordinate) {
      var _coordinateToDataRang = (0, _coordinateUtils.coordinateToDataRange)(coordinate, _this.getDataRange()),
        currentDisplayStartTime = _coordinateToDataRang.xFrom;
      _this.setState({
        currentDisplayStartTime: currentDisplayStartTime
      });
      _this.props.onTimeChanged(currentDisplayStartTime);
    });
    _defineProperty(_assertThisInitialized(_this), "getDataRange", function () {
      var _this$props2 = _this.props,
        startTime = _this$props2.startTime,
        endTime = _this$props2.endTime,
        nrOfChannels = _this$props2.nrOfChannels,
        channelDisplayCount = _this$props2.channelDisplayCount,
        displayTimespan = _this$props2.displayTimespan;
      return {
        xFrom: startTime,
        xStep: displayTimespan,
        yFrom: 0,
        yStep: channelDisplayCount,
        xTo: endTime,
        yTo: nrOfChannels
      };
    });
    _defineProperty(_assertThisInitialized(_this), "getGridBoundaries", function () {
      var dataRange = _this.getDataRange();
      var gridBoundaries = {
        xFrom: 0,
        xTo: (dataRange.xTo - dataRange.xFrom) / dataRange.xStep - 1,
        yFrom: 0,
        yTo: (dataRange.yTo - dataRange.yFrom) / dataRange.yStep - 1
      };
      return gridBoundaries;
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
      var _this$props$currentTi = _this.props.currentTime,
        currentTime = _this$props$currentTi === void 0 ? (0, _momentMini["default"])().valueOf() : _this$props$currentTi;
      return currentTime;
    });
    /**
     * Retrieves the time from which the program guide
     * should start displaying information.
     * If a ```displayStartTime``` prop is given, this
     * will be returned otherwise it will start from
     * the currentTime value subtracted with ```minuteOffset````
     * which is 30 by default.
     *
     * @param {number} minuteOffset Nr of minutes to subract from current time
     * @returns {number} The display start time
     */
    _defineProperty(_assertThisInitialized(_this), "getDisplayStartTime", function () {
      var minuteOffset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 30;
      var displayStartTime = _this.props.displayStartTime;
      var currentTime = _this.getCurrentTime();
      return displayStartTime || (0, _momentMini["default"])(currentTime).subtract(minuteOffset, 'minutes').valueOf();
    });
    /**
     * Retrieves the X coordinate in the
     * program guide grid which corresponds to
     * the given timestamp. If the timestamp is
     * outside of the program guide grid, it will return 0.
     *
     * @param {number} timestamp The timestamp to get the X coordinate for.
     * @returns {number} The X coordinate
     */
    _defineProperty(_assertThisInitialized(_this), "getXPositionFromTime", function (timestamp) {
      var _this$getDataRange = _this.getDataRange(),
        xFrom = _this$getDataRange.xFrom,
        xTo = _this$getDataRange.xTo,
        xStep = _this$getDataRange.xStep;
      return timestamp < xFrom || timestamp > xTo ? 0 : (timestamp - xFrom) / xStep;
    });
    /**
     * Retrieves the Y coordinate in the
     * program guide grid which corresponds to
     * the given channel index. If the channel index is
     * outside of the program guide grid, it will return 0.
     *
     * @param {number} channelIndex The channel index to get the Y coordinate for.
     * @returns {number} The Y coordinate
     */
    _defineProperty(_assertThisInitialized(_this), "getYPositionFromChannelIndex", function (channelIndex) {
      var _this$getDataRange2 = _this.getDataRange(),
        yFrom = _this$getDataRange2.yFrom,
        yTo = _this$getDataRange2.yTo,
        yStep = _this$getDataRange2.yStep;
      return channelIndex < yFrom || channelIndex > yTo ? 0 : (channelIndex - yFrom) / yStep;
    });
    _defineProperty(_assertThisInitialized(_this), "handleLeftBoundaryReached", function () {
      _this.props.vertical ? _this.handleBoundaryReached('Top', 'nextup') : _this.handleBoundaryReached('Left', 'nextleft');
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyContainerFocus", function () {
      _this.updateFocusState(true);
    });
    _defineProperty(_assertThisInitialized(_this), "handleBodyContainerBlur", function () {
      _this.updateFocusState(false);
    });
    _defineProperty(_assertThisInitialized(_this), "handleRightBoundaryReached", function () {
      _this.props.vertical ? _this.handleBoundaryReached('Down', 'nextdown') : _this.handleBoundaryReached('Right', 'nextright');
    });
    _defineProperty(_assertThisInitialized(_this), "handleTopBoundaryReached", function () {
      _this.props.vertical ? _this.handleBoundaryReached('Left', 'nextleft') : _this.handleBoundaryReached('Top', 'nextup');
    });
    _defineProperty(_assertThisInitialized(_this), "handleBottomBoundaryReached", function () {
      _this.props.vertical ? _this.handleBoundaryReached('Right', 'nextright') : _this.handleBoundaryReached('Bottom', 'nextdown');
    });
    /**
     * Handles the reach of a boundary (left, right, top, bottom) in the
     * data grid. Triggers any given event handlers and releases focus
     * if proper nav information and a changeFocus action are provided.
     * Supports both nav.(nextleft|nextright|nextup|nextdown) and nav.internals.
     *
     * @param {object} boundaryName The name of the boundary reached. For calling the right handler.
     * @param {object} navName The navigation name for the move causing the boundary reach.
     *
     * @return {Boolean} whether the focus has been changed properly or not
     */
    _defineProperty(_assertThisInitialized(_this), "handleBoundaryReached", function (boundaryName, navName) {
      var _this$props3 = _this.props,
        _this$props3$nav = _this$props3.nav,
        nav = _this$props3$nav === void 0 ? {} : _this$props3$nav,
        changeFocus = _this$props3.changeFocus;
      var boundaryFn = _this.props["on".concat(boundaryName, "BoundaryReached")];
      boundaryFn && boundaryFn();
      if (!nav) {
        return false;
      }
      var focusId = nav[navName];
      if (focusId) {
        return changeFocus && changeFocus(focusId);
      }
      var focusFn = nav.internals && nav.internals[navName];
      return focusFn && focusFn();
    });
    /**
     * Calculate the viewport for a given coordinate.
     *
     * @param {object} coordinate The coordinate to get the viewport for
     * @param {object} viewportRatio Possibility to provide another ratio than 1
     * @returns {object} The viewport object
     */
    _defineProperty(_assertThisInitialized(_this), "calculateViewPort", function (coordinate) {
      var viewportRatio = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        x: 1,
        y: 1
      };
      var x = coordinate.x,
        y = coordinate.y;
      return {
        xFrom: x,
        xTo: x + viewportRatio.x,
        yFrom: y,
        yTo: y + viewportRatio.y
      };
    });
    /**
     * A function for finding the first focusable program in
     * the viewport. Used when the EPG is receiving focus and
     * need to forward it to an inner program.
     * If a program is found, the focus ID for the program is stored
     * as an instance variable to be used for focusing the program
     * after the EPG has rendered.
     *
     * @param {object} coordinateData The collected coordinate data for the EPG
     *                                containing all loaded channel and program data.
     * @param {object} coordinate The current viewport coordinate used for
     *                            finding programs in view, matching against start time.
     * @returns {void}
     */
    _defineProperty(_assertThisInitialized(_this), "findFocusProgram", function (coordinateData, coordinate) {
      var selectedProgram = (0, _gridDataHelper.findFirstProgramForCoordinate)(coordinateData, coordinate, _this.getDataRange());
      // Storing this temporarily so we can focus the program
      // after the component has updated.
      var nextFocusId = selectedProgram ? selectedProgram.tileId : '';
      _this.setState({
        nextFocusId: nextFocusId
      });
    });
    _this.state = {
      currentDisplayStartTime: props.displayStartTime,
      nextFocusId: null
    };
    if (!_this.props.withFixedTimeline && _this.props.splitProgramsByTimespan) {
      console.error('VDKWeb Epg - when using splitProgramsByTimespan you should also use withFixedTimeline');
    }
    var _displayStartTime = _this.getDisplayStartTime();
    var _x2 = _this.getXPositionFromTime(_displayStartTime);
    var _y = _this.getYPositionFromChannelIndex(_this.props.initialChannelIndex) || 0;
    _this.state.initialCoordinate = _objectSpread({
      y: _y,
      x: _this.props.withFixedTimeline ? Math.floor(_x2) : _x2
    }, _this.props.initialCoordinate || {});
    return _this;
  }
  _createClass(ProgramGuide, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (this.state.nextFocusId !== prevState.nextFocusId) {
        this.updateProgramFocus();
      }
    }
  }, {
    key: "updateProgramFocus",
    value: function updateProgramFocus() {
      if (!this.state.nextFocusId) {
        return;
      }
      this.setState({
        nextFocusId: ''
      });
      this.props.changeFocus && this.props.changeFocus(this.state.nextFocusId);
    }
  }, {
    key: "updateFocusState",
    value: function updateFocusState(receivedFocus) {
      var x = this.getXPositionFromTime(this.props.displayStartTime) || 0;
      var y = this.getYPositionFromChannelIndex(this.props.initialChannelIndex) || 0;
      var markerCoordinate = {
        y: y,
        x: x
      };
      this.setState({
        receivedFocus: receivedFocus,
        markerCoordinate: markerCoordinate // eslint-disable-line react/no-unused-state
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props4 = this.props,
        animated = _this$props4.animated,
        id = _this$props4.id,
        dataId = _this$props4.dataId,
        bodyWidth = _this$props4.bodyWidth,
        bodyHeight = _this$props4.bodyHeight,
        draggable = _this$props4.draggable,
        leftColumnWidth = _this$props4.leftColumnWidth,
        headingHeight = _this$props4.headingHeight,
        headerHeight = _this$props4.headerHeight,
        preloadDistance = _this$props4.preloadDistance,
        renderDistance = _this$props4.renderDistance,
        stateType = _this$props4.stateType,
        onClickProgram = _this$props4.onClickProgram,
        onClickChannel = _this$props4.onClickChannel,
        theme = _this$props4.theme,
        components = _this$props4.components,
        currentTime = _this$props4.currentTime,
        movementRatio = _this$props4.movementRatio,
        renderOffscreen = _this$props4.renderOffscreen,
        showCurrentTimeMarker = _this$props4.showCurrentTimeMarker,
        vertical = _this$props4.vertical,
        updatedAt = _this$props4.updatedAt,
        rtl = _this$props4.rtl,
        startTime = _this$props4.startTime,
        endTime = _this$props4.endTime,
        withFixedTimeline = _this$props4.withFixedTimeline;
      var currentDisplayStartTime = this.state.currentDisplayStartTime;
      var nav = {
        id: id
      };
      var animation = animated ? AnimationProp.Enabled : AnimationProp.Disabled;
      var _defaultComponents$co = _objectSpread(_objectSpread({}, defaultComponents), components),
        Heading = _defaultComponents$co.Heading,
        Timeline = _defaultComponents$co.Timeline,
        ChannelColumn = _defaultComponents$co.ChannelColumn,
        NavigationButton = _defaultComponents$co.NavigationButton,
        BodyContainer = _defaultComponents$co.BodyContainer,
        LoadingTile = _defaultComponents$co.LoadingTile,
        ProgramGuideTile = _defaultComponents$co.ProgramGuideTile,
        CurrentTimeMarker = _defaultComponents$co.CurrentTimeMarker;
      var tileDimensions = {
        width: bodyWidth,
        height: bodyHeight
      };
      var dataRange = this.getDataRange();
      var gridBoundaries = this.getGridBoundaries();
      var minutePixelRatio = (vertical ? bodyHeight : bodyWidth) / (0, _timeHelper.msToMinutes)(dataRange.xStep);
      var timelineOuterContainerStyle = {
        width: vertical ? leftColumnWidth : bodyWidth + leftColumnWidth,
        height: vertical ? bodyHeight + headerHeight + headingHeight : headerHeight + headingHeight,
        left: 0
      };
      var currentTimeXPosition = this.getXPositionFromTime(this.getCurrentTime());
      var _this$props$component = this.props.componentsProps,
        _this$props$component2 = _this$props$component.Heading,
        headingProps = _this$props$component2 === void 0 ? emptyObj : _this$props$component2,
        _this$props$component3 = _this$props$component.Timeline,
        timelineProps = _this$props$component3 === void 0 ? emptyObj : _this$props$component3;
      var currentTimeMarkerProps = this.props.componentsProps.CurrentTimeMarker || emptyObj;
      var channelColumnProps = this.props.componentsProps.ChannelColumn || emptyObj;
      var programGuideTileProps = this.props.componentsProps.ProgramGuideTile || emptyObj;
      var bodyContainerProps = this.props.componentsProps.BodyContainer || emptyObj;
      var tileProps = {
        DataTile: /*#__PURE__*/_react["default"].createElement(ProgramGuideTile, _extends({
          animated: animated,
          components: components,
          componentsProps: this.props.componentsProps,
          currentTime: currentTime,
          draggable: draggable,
          epgEndTime: endTime,
          epgStartTime: startTime,
          onClickProgram: onClickProgram,
          rtl: rtl,
          withFixedTimeline: withFixedTimeline
        }, programGuideTileProps)),
        ErrorTile: null,
        height: tileDimensions.height,
        IdleTile: null,
        LoadingTile: LoadingTile && /*#__PURE__*/_react["default"].createElement(LoadingTile, null),
        width: tileDimensions.width
      };
      var dir = rtl ? 'rtl' : 'ltr';
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: theme.programGuide,
        dir: dir,
        style: {
          width: bodyWidth + leftColumnWidth,
          height: headerHeight + headingHeight + bodyHeight
        }
      }, /*#__PURE__*/_react["default"].createElement(_MovableDataGrid["default"], {
        dataId: dataId,
        epgEndTime: endTime,
        epgStartTime: startTime,
        gridBoundaries: gridBoundaries,
        initialMarkerCoordinate: this.state.initialCoordinate,
        movementRatio: movementRatio,
        onBottomBoundaryReached: this.handleBottomBoundaryReached,
        onCoordinateChange: this.onCoordinateChange,
        onLeftBoundaryReached: this.handleLeftBoundaryReached,
        onLoadCoordinateData: this.onLoadCoordinateData,
        onRightBoundaryReached: this.handleRightBoundaryReached,
        onTopBoundaryReached: this.handleTopBoundaryReached,
        preloadDistance: preloadDistance,
        stateType: stateType,
        updatedAt: updatedAt
      }, function (_ref9) {
        var _ref10, _ref11;
        var onUp = _ref9.onUp,
          onDown = _ref9.onDown,
          onLeft = _ref9.onLeft,
          onRight = _ref9.onRight,
          onMoveTo = _ref9.onMoveTo,
          transitionInfo = _ref9.transitionInfo,
          coordinateData = _ref9.coordinateData,
          markerCoordinate = _ref9.markerCoordinate,
          loadCoordinate = _ref9.loadCoordinate;
        if (_this2.state.receivedFocus) {
          _this2.findFocusProgram(coordinateData, markerCoordinate);
        }
        if (_this2.props.onElementPositionChange) {
          _this2.props.onElementPositionChange(markerCoordinate);
        }

        // We force the limit of the content based on the grid limits
        // to avoid setting the current visible to be more than the grid limits on start
        var xTo = gridBoundaries.xTo;
        var xOffset = markerCoordinate.x > xTo ? xTo : markerCoordinate.x;
        var timelineOffset = vertical ? -xOffset * bodyHeight + headerHeight + headingHeight : -xOffset * bodyWidth + leftColumnWidth;
        var transform = "translate".concat(vertical ? 'Y' : 'X', "(").concat(rtl ? -timelineOffset : timelineOffset, "px)");
        var timelineInnerContainerStyle = {
          transform: transform,
          marginTop: headingHeight ? "".concat(headingHeight, "px") : '',
          WebkitTransform: transform,
          transition: (0, _transition.animationToTransition)({
            disabled: !animated || draggable
          })
        };
        var channels = getChannelsFromGridDataMem(coordinateData);
        var timeMarkerPosition = vertical ? (currentTimeXPosition - xOffset) * bodyHeight + headerHeight : (currentTimeXPosition - xOffset) * bodyWidth + leftColumnWidth;
        var onNextClickHorizontal = rtl ? onLeft : onRight;
        var onPrevClickHorizontal = rtl ? onRight : onLeft;
        var visibleLeftHorizontal = rtl ? _coordinateUtils.isRightMostCoordinate : _coordinateUtils.isLeftMostCoordinate;
        var visibleRightHorizontal = rtl ? _coordinateUtils.isLeftMostCoordinate : _coordinateUtils.isRightMostCoordinate;
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
          style: (_ref10 = {
            position: 'absolute'
          }, _defineProperty(_ref10, rtl ? 'right' : 'left', leftColumnWidth), _defineProperty(_ref10, "top", headerHeight + headingHeight), _ref10)
        }, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.navigationButtonsContainer,
          style: {
            left: 0
          }
        }, /*#__PURE__*/_react["default"].createElement(NavigationButton, {
          direction: _NavigationButton.Direction.Right,
          left: bodyWidth - 40,
          onClick: vertical ? onDown : onNextClickHorizontal,
          text: "\u2192",
          top: bodyHeight / 2 - 80,
          visible: vertical ? !(0, _coordinateUtils.isBottomMostCoordinate)(markerCoordinate, gridBoundaries) : !visibleRightHorizontal(markerCoordinate, gridBoundaries)
        }), /*#__PURE__*/_react["default"].createElement(NavigationButton, {
          direction: _NavigationButton.Direction.Left,
          left: 0,
          onClick: vertical ? onUp : onPrevClickHorizontal,
          text: "\u2190",
          top: bodyHeight / 2 - 80,
          visible: vertical ? !(0, _coordinateUtils.isTopMostCoordinate)(markerCoordinate, gridBoundaries) : !visibleLeftHorizontal(markerCoordinate, gridBoundaries)
        }), /*#__PURE__*/_react["default"].createElement(NavigationButton, {
          direction: _NavigationButton.Direction.Up,
          left: bodyWidth / 2 - 80,
          onClick: vertical ? onLeft : onUp,
          text: "\u2191",
          visible: vertical ? !(0, _coordinateUtils.isLeftMostCoordinate)(markerCoordinate, gridBoundaries) : !(0, _coordinateUtils.isTopMostCoordinate)(markerCoordinate, gridBoundaries)
        }), /*#__PURE__*/_react["default"].createElement(NavigationButton, {
          direction: _NavigationButton.Direction.Down,
          left: bodyWidth / 2 - 80,
          onClick: vertical ? onRight : onDown,
          text: "\u2193",
          top: bodyHeight - 40,
          visible: vertical ? !(0, _coordinateUtils.isRightMostCoordinate)(markerCoordinate, gridBoundaries) : !(0, _coordinateUtils.isBottomMostCoordinate)(markerCoordinate, gridBoundaries)
        })), /*#__PURE__*/_react["default"].createElement(BodyContainer, _extends({
          nav: nav
        }, bodyContainerProps, {
          onBlur: _this2.handleBodyContainerBlur,
          onFocus: _this2.handleBodyContainerFocus
        }), /*#__PURE__*/_react["default"].createElement(_DataGridView["default"], {
          animation: animation,
          coordinateData: coordinateData,
          draggable: draggable,
          epgEndTime: endTime,
          epgStartTime: startTime,
          gridBoundaries: gridBoundaries,
          loadCoordinate: loadCoordinate,
          markerCoordinate: markerCoordinate,
          onDown: onDown,
          onLeft: onLeft,
          onMoveTo: onMoveTo,
          onRight: onRight,
          onUp: onUp,
          renderDistance: renderDistance || preloadDistance,
          renderOffscreen: renderOffscreen,
          rtl: rtl,
          theme: theme,
          tileDimensions: tileDimensions,
          tileProps: tileProps,
          transitionInfo: transitionInfo,
          vertical: vertical
        })))), showCurrentTimeMarker ? /*#__PURE__*/_react["default"].createElement(CurrentTimeMarker, _extends({
          animation: animation,
          getXPositionFromTime: _this2.getXPositionFromTime,
          length: vertical ? bodyWidth + leftColumnWidth : bodyHeight + headerHeight,
          offset: timeMarkerPosition,
          onLeft: onLeft,
          onMoveTo: onMoveTo,
          onRight: onRight,
          rtl: rtl,
          vertical: vertical
        }, currentTimeMarkerProps)) : '', /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.channelNameContainer,
          style: (_ref11 = {}, _defineProperty(_ref11, rtl ? 'right' : 'left', vertical ? leftColumnWidth : 0), _defineProperty(_ref11, "top", vertical ? 0 : headerHeight + headingHeight), _ref11)
        }, /*#__PURE__*/_react["default"].createElement(ChannelColumn, _extends({
          animation: animation,
          channelDisplayCount: dataRange.yStep,
          channels: channels,
          componentsProps: _this2.props.componentsProps,
          height: vertical ? headerHeight : bodyHeight,
          horizontal: vertical,
          nav: channelColumnNav,
          offset: markerCoordinate.y,
          onClickChannel: onClickChannel,
          onDown: onDown,
          onLeft: vertical ? onUp : onLeft,
          onMoveTo: onMoveTo,
          onRight: vertical ? onDown : onRight,
          onUp: onUp,
          theme: theme,
          width: vertical ? bodyWidth : leftColumnWidth
        }, channelColumnProps))), Heading ? /*#__PURE__*/_react["default"].createElement(Heading, _extends({}, headingProps, {
          currentDisplayStartTime: currentDisplayStartTime,
          getXPositionFromTime: _this2.getXPositionFromTime,
          onMoveTo: onMoveTo
        })) : null, /*#__PURE__*/_react["default"].createElement("div", {
          className: theme.timelineContainer,
          style: timelineOuterContainerStyle
        }, /*#__PURE__*/_react["default"].createElement("div", {
          style: timelineInnerContainerStyle
        }, /*#__PURE__*/_react["default"].createElement(Timeline, _extends({
          getXPositionFromTime: _this2.getXPositionFromTime,
          height: headerHeight,
          minutePixelRatio: minutePixelRatio,
          onMoveTo: onMoveTo,
          rtl: rtl,
          startTime: dataRange.xFrom,
          timeSpan: dataRange.xTo - dataRange.xFrom,
          vertical: vertical,
          width: vertical ? leftColumnWidth : bodyWidth + leftColumnWidth
        }, timelineProps)))));
      }));
    }
  }]);
  return ProgramGuide;
}(_react["default"].PureComponent);
exports.ProgramGuide = ProgramGuide;
ProgramGuide.propTypes = {
  /** Have the animation enabled, defaults to true */
  animated: _propTypes["default"].bool,
  /**
   * Decides if the program guide should automatically
   * adopt it's size to the container size.
   */
  autoSize: _propTypes["default"].bool,
  /**
   * Decides if the program guide should automatically
   * update with time.
   * If true, it will update once a minute, scrolling
   * the program guide horizontally and updating
   * the position of the current time marker.
   */
  autoUpdate: _propTypes["default"].bool,
  /** The height of the program listing body */
  bodyHeight: _propTypes["default"].number,
  /** The width of the program listing body */
  bodyWidth: _propTypes["default"].number,
  /**
   * Function to trigger for changing global focus to a specific ID.
   */
  changeFocus: _propTypes["default"].func,
  /** Decides how many channels to display in view at once */
  channelDisplayCount: _propTypes["default"].number,
  /** The list of overridable components, for where you can provide your own implementation */
  components: _propTypes["default"].shape({
    BodyContainer: _propTypes["default"].elementType,
    ChannelLane: _propTypes["default"].elementType,
    ChannelNameList: _propTypes["default"].elementType,
    CurrentTimeMarker: _propTypes["default"].elementType,
    ErrorTile: _propTypes["default"].elementType,
    Heading: _propTypes["default"].elementType,
    LoadingTile: _propTypes["default"].elementType,
    NavigationButton: _propTypes["default"].elementType,
    Program: _propTypes["default"].elementType,
    ProgramLane: _propTypes["default"].elementType,
    Timeline: _propTypes["default"].elementType
  }),
  /** Extra props passed to the components */
  componentsProps: _propTypes["default"].shape({
    BodyContainer: _propTypes["default"].object,
    ChannelColumn: _propTypes["default"].object,
    CurrentTimeMarker: _propTypes["default"].object,
    Heading: _propTypes["default"].object,
    Program: _propTypes["default"].object,
    ProgramGuideTile: _propTypes["default"].object,
    Timeline: _propTypes["default"].object
  }),
  /** The current time - deciding if a program is ongoing or not */
  currentTime: _propTypes["default"].number,
  dataId: _propTypes["default"].string,
  /**
   * The time deciding from where the guide should start
   * showing program data. This needs to be within the
   * time window of startTime and endTime
   */
  displayStartTime: _propTypes["default"].number,
  /** The timespan in milliseconds to show in view */
  displayTimespan: _propTypes["default"].number,
  /** Grid can be dragged */
  draggable: _propTypes["default"].bool,
  /**
   * The overall end time of the guide,
   * deciding the right most boundary of the timeline
   */
  endTime: _propTypes["default"].number,
  /** The height of the header container including the timeline */
  headerHeight: _propTypes["default"].number,
  /** The height of the heading container above the timeline */
  headingHeight: _propTypes["default"].number,
  /** The ID of the program guide - used for focus navigation */
  id: _propTypes["default"].string,
  initialChannelIndex: _propTypes["default"].number,
  initialCoordinate: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  /** The width of the channel listing column */
  leftColumnWidth: _propTypes["default"].number,
  /**
   * The percentage ratio of how far to navigate a view when
   * using directional navigation (up, down, right, left).
   * The percentage is based on the bodyWidth / bodyHeight.
   * Values are given for both the X- and Y-axis.
   */
  movementRatio: _propTypes["default"].shape({
    x: _propTypes["default"].number,
    y: _propTypes["default"].number
  }),
  /**
   * Navigation object for giving focus management instructions.
   */
  nav: _propTypes["default"].shape({
    internals: _propTypes["default"].shape({
      nextdown: _propTypes["default"].func,
      nextleft: _propTypes["default"].func,
      nextright: _propTypes["default"].func,
      nextup: _propTypes["default"].func
    }),
    nextdown: _propTypes["default"].string,
    nextleft: _propTypes["default"].string,
    nextright: _propTypes["default"].string,
    nextup: _propTypes["default"].string
  }),
  /** The total number of channels to load for the guide */
  nrOfChannels: _propTypes["default"].number.isRequired,
  /**
   * Handler triggered when the bottom boundary of the program
   * guide body is reached by key navigation
   */
  onBottomBoundaryReached: _propTypes["default"].func,
  /** Click handler for clicking a channel in the channel list column */
  onClickChannel: _propTypes["default"].func,
  /** Click handler for clicking a program */
  onClickProgram: _propTypes["default"].func,
  /** Function to execute when new data has been loaded */
  onDataLoaded: _propTypes["default"].func,
  /** Function to execute when the position of the DataGrid has changed */
  onElementPositionChange: _propTypes["default"].func,
  /**
   * A function for providing TV listings information.
   * This will be called when loading the guide and
   * whenever the guide needs more information to show,
   * e.g. in the event of pagination.
   *
   * Should have the following interface:
   *
   * ```onGetTvListings({ startTime, endTime, offset, count })```
   *
   * startTime: timestamp for the initial point of the data block to be requested
   * endTime: timestamp for the final point of the data block to be requested
   * offset: channel offset for the channel pagination
   * count: number of channels to request
   */
  onGetTvListings: _propTypes["default"].func.isRequired,
  /**
   * Handler triggered when the left boundary of the program
   * guide body is reached by key navigation
   */
  onLeftBoundaryReached: _propTypes["default"].func,
  /**
   * Handler triggered when the right boundary of the program
   * guide body is reached by key navigation
   */
  onRightBoundaryReached: _propTypes["default"].func,
  /**
   * Handler triggered when timeline position has changed
   * via scrolling, dragging
   */
  onTimeChanged: _propTypes["default"].func,
  /**
   * Handler triggered when the top boundary of the program
   * guide body is reached by key navigation
   */
  onTopBoundaryReached: _propTypes["default"].func,
  /**
   * Affects the loading behaviour of data which is not in view.
   * Read about the datagrid approach for more information.
   */
  preloadDistance: _propTypes["default"].number,
  /**
   * Affects the rendering of data tiles which are not in view.
   * Read about the datagrid approach for more information.
   */
  renderDistance: _propTypes["default"].number,
  /**
   * Keep rendering offscreen coordinates:
   * when turned off, dragging 100+ row grids the remounting of hidden
   * areas causes noticeable freezes in movement
   * turning it off keeps everything in the DOM
   */
  renderOffscreen: _propTypes["default"].bool,
  /** Right to left */
  rtl: _propTypes["default"].bool,
  /**
   * Decides if a marker line should be shown for
   * the current time.
   */
  showCurrentTimeMarker: _propTypes["default"].bool,
  /**
   * Split programs in the limit of the displayed timeline, requires
   * the props: withFixedTimeline: true
   */
  splitProgramsByTimespan: _propTypes["default"].bool,
  /**
   * The overall start time of the guide,
   * deciding the left most boundary of the timeline
   */
  startTime: _propTypes["default"].number,
  /**
   * Decides the mechanism for state management.
   * Can choose between using Redux or internal setState. */
  stateType: _propTypes["default"].oneOf(['redux', 'setState']),
  /** The classname API for theming the outer parts of the program guide */
  theme: _propTypes["default"].shape({
    channelNameContainer: _propTypes["default"].string,
    navigationButtonsContainer: _propTypes["default"].string,
    programGuide: _propTypes["default"].string,
    timelineContainer: _propTypes["default"].string
  }),
  /**
   * Changing this timestamp after mount will
   * trigger a refresh of all stored data
   */
  updatedAt: _propTypes["default"].number,
  /**
   * The auto update interval in milliseconds.
   * If autoUpdate is enabled, it will trigger
   * a new render once every interval.
   */
  updateInterval: _propTypes["default"].number,
  /**
   * If programs are to be layed out vertically
   * instead of horizontally.
   */
  vertical: _propTypes["default"].bool,
  /** Have the timeline in a fixed position */
  withFixedTimeline: _propTypes["default"].bool
};
ProgramGuide.defaultProps = {
  animated: true,
  autoUpdate: true,
  bodyHeight: 400,
  bodyWidth: 1000,
  channelDisplayCount: 5,
  componentsProps: {},
  displayTimespan: 4 * 60 * 60 * 1000,
  endTime: (0, _momentMini["default"])().endOf('day').valueOf(),
  headerHeight: defaultHeaderHeight,
  headingHeight: 0,
  id: 'program-guide',
  leftColumnWidth: defaultLeftColumnWidth,
  movementRatio: {
    x: 2 / 3,
    y: 4 / 5
  },
  onTimeChanged: _general.NOOP,
  preloadDistance: 1,
  showCurrentTimeMarker: true,
  splitProgramsByTimespan: false,
  startTime: (0, _momentMini["default"])().startOf('day').valueOf(),
  stateType: 'setState',
  theme: _programGuide["default"],
  updateInterval: 30 * 1000,
  vertical: false,
  withFixedTimeline: false
};
var sizeHandlerProps = {
  mapProps: function mapProps(_ref12) {
    var width = _ref12.width,
      height = _ref12.height,
      _ref12$leftColumnWidt = _ref12.leftColumnWidth,
      leftColumnWidth = _ref12$leftColumnWidt === void 0 ? defaultLeftColumnWidth : _ref12$leftColumnWidt,
      _ref12$headerHeight = _ref12.headerHeight,
      headerHeight = _ref12$headerHeight === void 0 ? defaultHeaderHeight : _ref12$headerHeight;
    return {
      bodyWidth: width - leftColumnWidth,
      bodyHeight: height - headerHeight
    };
  }
};
var withAutoSize = function withAutoSize(Component) {
  var ComponentWithSizeHandler = (0, _withSizeHandler["default"])(sizeHandlerProps)(Component);

  // eslint-disable-next-line react/prop-types
  return function (_ref13) {
    var _ref13$autoSize = _ref13.autoSize,
      autoSize = _ref13$autoSize === void 0 ? true : _ref13$autoSize,
      rest = _objectWithoutProperties(_ref13, _excluded);
    var Comp = autoSize ? ComponentWithSizeHandler : Component;
    return /*#__PURE__*/_react["default"].createElement(Comp, rest);
  };
};
var timeProviderProps = {
  mapProps: function mapProps(_ref14) {
    var time = _ref14.time;
    return {
      currentTime: time
    };
  }
};
var withAutoUpdate = function withAutoUpdate(Component) {
  var ComponentWithTimeProvider = (0, _withTimeProvider["default"])(timeProviderProps)(Component);

  // eslint-disable-next-line react/prop-types
  return function (_ref15) {
    var _ref15$autoUpdate = _ref15.autoUpdate,
      autoUpdate = _ref15$autoUpdate === void 0 ? true : _ref15$autoUpdate,
      rest = _objectWithoutProperties(_ref15, _excluded2);
    var Comp = autoUpdate ? ComponentWithTimeProvider : Component;
    return /*#__PURE__*/_react["default"].createElement(Comp, rest);
  };
};
var enhance = (0, _redux.compose)(withAutoSize, withAutoUpdate);
var _default = enhance(ProgramGuide);
exports["default"] = _default;